import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { tap, catchError, finalize } from 'rxjs/operators';
import { LoaderService } from './loader.service';
import { ErrorsService } from '../shared/services/errors.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LoaderInterceptor implements HttpInterceptor {
  private static pendingHttpCalls = 0;
  allowAnimate = false;
  private _ignoreApis = [environment.signalRUrl];
  constructor(
    private loaderService: LoaderService,
    private errorsService: ErrorsService
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isPost = req.method.toLowerCase() === 'post' || req.method.toLowerCase() === 'put';
    const trackLoader = this._ignoreApis.findIndex(api => req.url.startsWith(api)) === -1;
    if (trackLoader) {
      LoaderInterceptor.pendingHttpCalls++;
      if (LoaderInterceptor.pendingHttpCalls === 1) {
        this.showLoader(isPost);
      }
    }
    return next.handle(req).pipe(
      catchError(this.onCatch),
      tap(
        (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            this.onSuccess(event);
          }
        },
        (err: any) => {
          this.onError(err);
        }
      ),
      finalize(() => {
        if (trackLoader) {
          LoaderInterceptor.pendingHttpCalls = Math.max(0, LoaderInterceptor.pendingHttpCalls - 1);
          if (LoaderInterceptor.pendingHttpCalls === 0) {
            this.onEnd();
          }
        }
      })
    );
  }
  private onCatch(error: any, caught: Observable<any>): Observable<any> {
    return observableThrowError(error);
  }

  private onSuccess(res: HttpResponse<any>): void {
  }

  private onError(res: HttpResponse<any>): void {
    this.errorsService.addError({ code: res.status });
    console.log('Error, status code: ' + res.status);
  }

  private onEnd(): void {
    this.loaderService.reset();
  }

  private showLoader(isPost: boolean): void {
    this.allowAnimate = true;
    this.loaderService.show(isPost);
  }

  private hideLoader(): void {
    this.allowAnimate = false;
    this.loaderService.hide();
  }
}
